import styled from 'styled-components';
type DataProps = {
  width: string;
  gridArea?: string;
};

export const Data = styled.div<DataProps>`
  width: ${(props) => props.width};
  font-weight: bold;
  text-align: left;
  &.checkbox_table {
    margin-right: 20px;
  }
  .checkbox_text{
    display: none;
  }
  @media screen and (max-width: 960px) {
    .checkbox_text{
      display: flex;
    }
    &.checkbox_all{
      margin-right: 0px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px
    }
    &.checkbox_table {
      display: flex;
    }
    &.checkbox_table {
      display: none;
    }
    &.hidden {
      display: none;
    }
    &#recipes-executions {
      width: auto;
      grid-area: ${(props) => props.gridArea};
    }
    &#error-logs {
      width: auto;
      min-width: 0;
      grid-area: ${(props) => props.gridArea};
      padding-left: 4px;
    }
  }
`;

export const Tooltip = styled.div`
  visibility: hidden;
  background-color: white;
  color: #004992;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 12px;
  border-radius: 5px;
  padding: 5px 10px;
  position: absolute;
  top: -20%;
  left: 130%;
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
  box-shadow: 0 0 0.7em ${props => props.theme.colors.boxShadow};
  border: 1px solid #004992;
 
  &::after {
    content: "";
    position: absolute;
    top: 30%;
    right: 0;
  }
`;

export const DataDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  &.showTooltip {
    position: relative;
    display: inline-block;
    overflow: visible;
  
    &:hover > ${Tooltip} {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const THeader = styled.div`
  padding: 8px 20px;
  display: flex;

  padding-right: 30px;
  box-sizing: border-box;



  &.haccp-table {
    gap: 8px;
    padding-right: 34px;

    > div {
      min-width: 0;
    }

    .checkbox_table {
      margin-right: 8px;
      width: 26px;
      min-width: 26px;
      flex: 0 0 26px;
    }

    > div:nth-child(2) {
      flex: 1;
    }

    > div:last-child {
      margin-left: auto;
      text-align: left;
    }
  }
  
  &.force-scroll {
    margin-right: 10px;
  }

  @media screen and (max-width: 960px) {
    display: none;

    &.serialNumbers-table{
      display: flex;
      justify-content: flex-end;
      padding: 8px 14px;
    }

    &.checkbox_table {
      display: flex;
    }

    &.show_header_mobile {
      display: flex;
    }

    &#details-equipment {
      display: grid;
      width: 100%;
      grid-template-columns: minmax(0, 1fr) 70px 45px;
      column-gap: 12px;
      padding: 8px 20px;

      > div {
        width: 100%;
        min-width: 0;
        padding: 0;
        margin: 0;
        font-size: 12px;
        font-weight: 500;
      }

      > div:last-child {
        width: auto;
        justify-self: end;

        > div {
          justify-content: flex-end;
        }
      }
    }

    &#recipes-executions {
      display: grid;
      width: 100%;
      grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.2fr) minmax(0, 0.9fr);
      grid-template-areas: 'title data1 data2';
      column-gap: 12px;
      padding: 8px 12px;

      > div:nth-child(4),
      > div:nth-child(5) {
        display: none;
      }
    }

    &#error-logs {
      display: grid;
      width: 100%;
      grid-template-columns: minmax(0, 2.2fr) minmax(0, 1fr) minmax(0, 1fr);
      grid-template-areas: 'title data1 hour';
      column-gap: 12px;
      padding: 8px 4px;

      > div:nth-child(2),
      > div:nth-child(3) {
        padding-left: 8px;
      }
    }

    &#baking-station-oven-table,
    &#baking-station-proofer-table {
      display: grid;
      width: 100%;
      grid-template-columns: minmax(0, 1fr) 80px 44px;
      column-gap: 12px;
      padding: 8px 20px;

      > div {
        width: auto;
        min-width: 0;
        padding: 0;
        margin: 0;
        font-size: 12px;
        font-weight: 500;
      }

      > div:last-child {
        text-align: right;

        > div {
          justify-content: flex-end;
        }
      }
    }

    &#cleaning-executions {
      display: grid;
      width: 100%;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      grid-template-areas: 'date hour';
      column-gap: 8px;
      padding: 8px 20px;
    }

    &#cleaning-executions-tsi {
      display: grid;
      width: 100%;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.05fr) minmax(0, 1.05fr);
      grid-template-areas: 'done recommended date hour';
      column-gap: 8px;
      padding: 8px 20px;
    }

    &#cleaning-executions-support {
      display: grid;
      width: 100%;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.5fr) minmax(0, 0.6fr) minmax(0, 1.05fr) minmax(0, 1.05fr);
      grid-template-areas: 'done recommended liters kwh date hour';
      column-gap: 6px;
      padding: 8px 20px;
    }
  }
`;


